import { render, staticRenderFns } from "./warranty-forms.vue?vue&type=template&id=07c6835a&"
import script from "./warranty-forms.vue?vue&type=script&lang=js&"
export * from "./warranty-forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports